import { category as categoryUtils } from 'utils';

export const isCategorySearch = ({ location, listingType }) => {
    const query = categoryUtils.getQueryFromLocation(location);
    if (listingType === 'search') return true;
    if (listingType === 'category' && query) return true;
    return false;
};

export default isCategorySearch;
